import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { AgreementRequestModel, ServiceAgreementPatchRequestModel } from '@fs/models/agreement/request.model';
import { Injectable } from '@angular/core';
import { DataSourceRequestState } from '@progress/kendo-data-query';

@Injectable()
export class AgreementService {
    constructor(private auth: AuthService, private httpRepo: HttpRepo) {
        this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
    }

    // GET List
    GetServiceAgreementList(state: DataSourceRequestState, searchKey: string, references: string = null) {
    return this.httpRepo.Get("serviceagreements", this.httpRepo.GetCommonURLQueryParams(state, searchKey, references));
    }
    PostAgreement(jobsiteId: string, data: AgreementRequestModel) {
        data.ID = '00000000-0000-0000-0000-000000000000';
        return this.httpRepo.Post("jobsites/" + jobsiteId + "/serviceagreements", data);
    }
    GetAgreement(jobsiteId: string, agreementId) {
        return this.httpRepo.Get("jobsites/" + jobsiteId + "/serviceagreements/" + agreementId);
    }
    ChangeAgreementStatus(jobsiteId: string, agreementId, data: ServiceAgreementPatchRequestModel) {
        return this.httpRepo.Patch("jobsites/" + jobsiteId + "/serviceagreements/" + agreementId, data);
    }
    PutAgreement(jobsiteId: string, data: AgreementRequestModel) {
        return this.httpRepo.Put("jobsites/" + jobsiteId + "/serviceagreements/" + data.ID, data);
    }
    GetJobSiteAgreementList(jobsiteId: string, state: DataSourceRequestState, references: string = null) {
        return this.httpRepo.Get("jobsites/" + jobsiteId + "/serviceagreements", this.httpRepo.GetCommonURLQueryParams(state, "", references));
    }
    PrintAgreement(agreementId) {
        return this.httpRepo.GetFile("serviceagreement/" + agreementId + "/print");
    }
}